import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-solid-svg-icons";

const LikedPlatesButton = () => {
  return (
    <Link
      to="/liked"
      className="relative text-gray-400 hover:text-gray-500 transition-colors dark:text-gray-400 dark:hover:text-gray-300"
      aria-label="Liked Plates"
    >
      <FontAwesomeIcon icon={faHeart} className="text-md" />
    </Link>
  );
};

export default LikedPlatesButton;
